import Swal from 'sweetalert2';

export const SwalService = {
  triggerSwal: (title: string, text: string, confirmAction: () => void) => {
    Swal.fire({
      title: title || 'Are you sure?',
      text: text || 'Do you really want to continue?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continue!',
      cancelButtonText: 'Cancel',
      customClass: {
        container: 'bg-gray-800',
        popup: 'bg-white rounded-lg shadow-lg p-6',
        title: 'text-2xl font-semibold text-red-500',
        confirmButton: 'bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded',
        cancelButton: 'bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        confirmAction();
      }
    });
  }
};
